/**
 * Storm Navigation
 *
 * @author Billy Bastardi (billy@yext.com)
 * @author MattJS (matt@yext.com)
 *
 * Storm Navigation Drop Down Navigation
 *
 */
goog.provide('yext.storm.navigation');

yext.storm.navigation.init = function() {
  return new yext.storm.navigation.StormNavigation();
};

/**
 * Handles the navigation drop downs interaction
 * @constructor
 */
yext.storm.navigation.StormNavigation = function() {
  this.bindInteraction();
  this.initalizeSubnavigation();
  this.bindUnderlineAnimation();
};

// Bind the interaction
yext.storm.navigation.StormNavigation.prototype.bindInteraction = function() {
  $('.js-dropdown-nav').each(function() {
    var $this = $(this);
    var timeout;

    const clearTimeoutAndShow = e => {
      clearTimeout(timeout);
      var $subNav = $this.find('.js-sub-nav');
      $subNav.show();
    };

    $this.on('click', clearTimeoutAndShow);
    $this.on('mouseenter', clearTimeoutAndShow);

    $this.on('mouseleave', function(e) {
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        var $subNav = $this.find('.js-sub-nav');
        $subNav.hide();
      }, 200);
    });
  });
};

/*
 * Makes the underline on the primary navbar move to whichever element is hovered.
 */
yext.storm.navigation.StormNavigation.prototype.bindUnderlineAnimation = function() {
  var primaryNavDelay = 100;
  var secondaryNavDelay = 1000;
  window['primaryNavDelay'] = primaryNavDelay;
  window['secondaryNavDelay'] = secondaryNavDelay;
  var $underline = $('.js-nav-underline');
  if (!$underline.length) {
    return;
  }

  // NOTE(amullings): I've seen this code grab the wrong element width when run immediately, so
  // I've delayed it to reduce the likelyhood of that happening.
  setTimeout(function() {
    var reset = function() {
      moveAndResizeElement($underline, 0, 0);
    };

    var $activeNavItem = $('.js-nav-underline-target.js-underlined');
    if ($activeNavItem.length) {
      reset = function() {
        matchWidthAndPosition($underline, $activeNavItem);
      };
    }

    var update = function(e) {
      matchWidthAndPosition($underline, $(e.target));
    };
    reset();
    toggleSecondNavOnHover(update, reset);
  }, 100);
};

var matchWidthAndPosition = function($elem, $target) {
  var newLeft = getNavItemPosition($target);
  var newWidth = getNavItemWidth($target);
  moveAndResizeElement($elem, newLeft, newWidth);
};

var getNavItemWidth = function($elem) {
  return $elem.width();
};

var getNavItemPosition = function($elem) {
  return $elem.children().first().position()['left'];
};

var moveAndResizeElement = function($elem, left, width) {
  $elem.css('left', left);
  $elem.width(width);
};

/*
 * Sets the of the sub-navigation so that it aligns underneath the active section
 */
yext.storm.navigation.StormNavigation.prototype.initalizeSubnavigation = function() {
  $('#sub-navigation').addClass('show-nav');
};

/*
 * Sets navigation bar hover behavior
 */
var toggleSecondNavOnHover = function(updateUnderBar, resetUnderBar) {
  var timeout = undefined;
  var primaryHeadersElem = document.getElementsByClassName('js-yext-navbar');
  if (primaryHeadersElem.length > 0) {
    const primaryHeaders = JSON.parse(primaryHeadersElem[0].innerHTML);
    const primaryHeadersTrimmed = {};
    for (const key in primaryHeaders) {
      primaryHeadersTrimmed[key.trim()] = primaryHeaders[key];
    }
    const activeNavItem = document.querySelector('.secondary-nav.active');

    var hideAllSecondNav = function() {
      document.querySelectorAll('.secondary-nav.active').forEach(nav => {
        nav.classList.remove('active');
        nav.removeEventListener('mouseenter', handleMouseEnterSecondNav);
        nav.removeEventListener('mouseleave', handleMouseLeaveSecondNav);
      });
    };

    var resetSecondNav = function() {
      hideAllSecondNav();
      if (activeNavItem) {
        activeNavItem.classList.add('active');
      }
    };

    var handleMouseEnterSecondNav = function(e) {
      clearTimeout(timeout);
    };

    var handleMouseLeaveSecondNav = function(e) {
      // reset both underbar and secondNav change on leave with 1s lag
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        resetSecondNav();
        resetUnderBar();
      }, window['secondaryNavDelay']);
    };

    var updateSecondNav = function(sectionName) {
      const secondNavElem = document.getElementById(sectionName);
      hideAllSecondNav();
      if (secondNavElem) {
        secondNavElem.classList.add('active');
        secondNavElem.addEventListener('mouseenter', handleMouseEnterSecondNav);
        secondNavElem.addEventListener('mouseleave', handleMouseLeaveSecondNav);
      }
    };

    document.querySelectorAll('.primary-nav-item').forEach(item => {
      item.addEventListener('mouseenter', e => {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          updateUnderBar(e);
          updateSecondNav(primaryHeadersTrimmed[item.innerText.trim()]);
        }, window['primaryNavDelay']);
      });
      item.addEventListener('mouseleave', e => {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          resetUnderBar();
          resetSecondNav();
        }, window['secondaryNavDelay']);
      });
    });
  } else {
    document.querySelectorAll('.primary-nav-item').forEach(item => {
      item.addEventListener('mouseenter', updateUnderBar);
      item.addEventListener('mouseleave', resetUnderBar);
    });
  }
};
